import * as React from "react";
import * as ComponentBase from "VSS/Flux/Component";
import { TCMReleaseListenerComponent, IReleaseListenerProps } from "Test/TestTabInRelease/Components/TCMReleaseListenerComponent";
import { ReactRootComponent } from "VSS/Platform/Layout";
import { Store } from "VSS/Flux/Store";
import { IViewContextData } from "TestManagement/Scripts/TestReporting/TestTabExtension/Common";
import { Action } from "VSS/Flux/Action";

export interface IExtensionReleaseEnvShimProps extends ComponentBase.Props {
    pageContext: any;
    store: ExtensionReleaseEnvironmentShimStore;
}

export interface IExtensionReleaseEnvShimState extends ComponentBase.State {
    releaseListenerProps: IReleaseListenerProps;
}

// wrapper around the new web platform component to pass the context.
export class ExtensionReleaseEnvironmentShim extends ComponentBase.Component<IExtensionReleaseEnvShimProps, IExtensionReleaseEnvShimState> {

    constructor(props: IExtensionReleaseEnvShimProps) {
        super(props);
        this._store = this.props.store;
        this.state = { releaseListenerProps: this._store.getState().releaseListenerProps };
    }

    public componentDidMount() {
        this._store.addChangedListener(this._handleStoreChange);
    }

    public componentWillUnmount() {
        this._store.removeChangedListener(this._handleStoreChange);
    }

    public render(): JSX.Element {
        return (<ReactRootComponent pageContext = {this.props.pageContext}>
                <TCMReleaseListenerComponent {...this.state.releaseListenerProps}>
                </TCMReleaseListenerComponent>
            </ReactRootComponent>);
    }

    private _handleStoreChange = () => {
        this.setState(this._store.getState());
    }

    private _store: ExtensionReleaseEnvironmentShimStore;
}


export class ExtensionReleaseEnvironmentShimStore extends Store {
    private _state: IExtensionReleaseEnvShimState;

    constructor(private _actionHub: ExtensionReleaseEnvironmentShimActionHub, private _artifactData: IViewContextData) {
        super();
        this._state = { releaseListenerProps: {artifactData: this._artifactData} };
        this._actionHub.updateInReleaseEnvironment.addListener(this._updateInReleaseEnvironment);
    }

    public getState() {
        return this._state;
    }

    private _updateInReleaseEnvironment = (artifactData: IViewContextData) => {
        this._state.releaseListenerProps.artifactData = artifactData;
        this.emitChanged();
    }

    public dispose() {
        this._actionHub.updateInReleaseEnvironment.addListener(this._updateInReleaseEnvironment);
    }

}

export class ExtensionReleaseEnvironmentShimActionHub {
    public updateInReleaseEnvironment = new Action<IViewContextData>();
}
